<template>
  <div>
    <draggable
      v-model="places"
      class="list-group list-group-flush draggable-list"
      tag="ul"
      :disabled="!customize"
    >
      <transition-group
        type="transition"
        name="flip-list"
      >
        <div
          v-for="component in places"
          :key="component.type+'_'+component.id"
        >
          <case-statements
            v-if="component.id === 1 && component.type === 'default'"
            key="case-statements"
            ref="case-statements-child"
            :custom-change="customize"
            :side="side"
          />
          <case-documents
            v-if="component.id === 2 && component.type === 'default'"
            key="case-documents"
            ref="case-documents-child"
            :custom-change="customize"
            :side="side"
          />
          <case-payments
            v-if="component.id === 3 && component.type === 'default'"
            key="case-payments"
            ref="case-payments-child"
            :custom-change="customize"
            :side="side"
          />
          <case-installement-plan
            v-if="component.id === 4 && component.type === 'default'"
            key="case-installement-plan"
            ref="case-installement-plan-child"
            :custom-change="customize"
            :side="side"
          />
          <case-betaling-invoices
            v-if="component.id === 5 && component.type === 'default'"
            key="case-betaling-invoices"
            ref="case-betaling-invoices-child"
            :custom-change="customize"
            :side="side"
          />
          <case-invoices
            v-if="component.id === 6 && component.type === 'default'"
            key="case-invoices"
            ref="case-invoices-child"
            :custom-change="customize"
            :side="side"
          />
          <case-identities
            v-if="bcCaseId && component.id === 7 && component.type === 'default'"
            key="case-identities"
            ref="case-identities-child"
            :custom-change="customize"
            :side="side"
          />
          <case-notes
            v-if="component.id === 8 && component.type === 'default'"
            key="case-notes"
            ref="case-notes-child"
            :custom-change="customize"
            :side="side"
          />
          <case-logs-history
            v-if="component.id === 9 && component.type === 'default'"
            key="case-logs-history"
            ref="case-logs-history-child"
            :custom-change="customize"
            :side="side"
          />
          <!-- <custom-field-widget
            v-if="component.type === 'custom' && component.data.type === 'custom_field'"
            :title="component.data.title"
            :data="component.data.custom_widget_data"
            :custom-change="customize"
            :widget-id="component.id"
            :side="side"
          /> -->
        </div>
      </transition-group>
    </draggable>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { EventBus } from '@/event-bus'
import CaseStatements from './childcomponents/CaseStatements.vue'
import CaseDocuments from './childcomponents/CaseDocuments.vue'
import CasePayments from './childcomponents/CasePayments.vue'
import CaseInstallementPlan from './childcomponents/CaseInstallementPlan.vue'
import CaseInvoices from './childcomponents/CaseInvoices.vue'
import CaseIdentities from './childcomponents/CaseIdentities.vue'
import CaseNotes from './childcomponents/CaseNotes.vue'
import CaseLogsHistory from './childcomponents/CaseLogsHistory.vue'
import CaseBetalingInvoices from './childcomponents/CaseBetalingInvoices.vue'
// import CustomFieldWidget from './childcomponents/CustomFieldWidget.vue'

export default {
  components: {
    CaseStatements,
    CaseDocuments,
    CasePayments,
    CaseInstallementPlan,
    CaseInvoices,
    CaseIdentities,
    CaseNotes,
    CaseLogsHistory,
    CaseBetalingInvoices,
    draggable,
    // CustomFieldWidget,
  },
  props: {
    side: {
      type: String,
      required: true,
    },
    places: {
      type: Array,
      required: true,
    },
    bcCaseId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      customize: false,
      widgetComponents: [],
    }
  },
  watch: {
    places: {
      handler() {
        this.widgetComponents = [...this.places]
      },
    },
  },
  created() {
    EventBus.$on('dragClicked', () => {
      this.customizeFunction()
    })
  },
  methods: {
    runLeftInnerChildAPIs() {
      this.$refs['case-statements-child'][0].fetchInitialData()
      this.$refs['case-documents-child'][0].fetchInitialData()
      this.$refs['case-payments-child'][0].fetchInitialData()
      this.$refs['case-installement-plan-child'][0].fetchInitialData()
      this.$refs['case-betaling-invoices-child'][0].fetchInitialData()
      this.$refs['case-invoices-child'][0].fetchInitialData()
    },
    runRightInnerChildAPIs() {
      this.$refs['case-identities-child'][0].fetchInitialData()
      this.$refs['case-notes-child'][0].fetchInitialData()
      this.$refs['case-logs-history-child'][0].fetchInitialData()
    },
    customizeFunction() {
      this.customize = !this.customize
    },
  },
}
</script>

<style lang="scss">
.cancel-btn {
  margin-right: 20px !important;
  margin-top: 10px;
}
</style>
